import { Observable, of } from 'rxjs';

import { IModule } from 'module/module';

export interface IUserModuleSuggestion {
	readonly userId: string;
	readonly priority: number;
	readonly orgModuleId: string;
	readonly orgModule$: Observable<IModule>;
}

export class UserModuleSuggestion implements IUserModuleSuggestion {
	private _userId: string;
	private _priority: number;
	private _orgModuleId: string;
	private _orgModule$: Observable<IModule>;

	constructor(
		userId: string,
		priority: number,
		orgModuleId: string,
		orgModule$: Observable<IModule> = of(null)
	) {
		this._userId = userId;
		this._priority = priority;
		this._orgModuleId = orgModuleId;
		this._orgModule$ = orgModule$;
	}

	get userId(): string {
		return this._userId;
	}

	get priority(): number {
		return this._priority;
	}

	get orgModuleId(): string {
		return this._orgModuleId;
	}

	get orgModule$(): Observable<IModule> {
		return this._orgModule$;
	}
}
